import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import VisibilityIcon from '@mui/icons-material/Visibility'
import getButtonCell from 'components/generic/datagrid/cells/ButtonCell'
import DataGridWithSearch from 'components/generic/datagrid/DataGridWithSearch'
import { formatNumber } from 'utils/helpers'
import { generateRenderHeaderFunction } from 'utils/generateRenderHeaderFunction'
import { SORTABLE_FINISHED_GOOD_FIELDS } from 'utils/constants'

const getColumns = (navigate, renderHeaderWithSort, defaultYardUm, enablePullApartFeatures) => {
  const columns = [
    {
      field: 'tag',
      headerName: 'FG #',
      renderHeader: () => renderHeaderWithSort('FG #', SORTABLE_FINISHED_GOOD_FIELDS.TAG, { startAscending: false }),
      sortable: false,
      flex: 1,
    },
    {
      field: 'purchaseOrderNumber',
      headerName: 'PO #',
      sortable: false,
      flex: 1,
    },
    {
      field: 'effectiveDate',
      headerName: 'Effective Date',
      renderHeader: () =>
        renderHeaderWithSort('Effective Date', SORTABLE_FINISHED_GOOD_FIELDS.EFFECTIVE_DATE, { startAscending: false }),
      sortable: false,
      flex: 1,
    },
    {
      field: 'commodity',
      headerName: 'Commodity',
      renderHeader: () =>
        renderHeaderWithSort('Commodity', SORTABLE_FINISHED_GOOD_FIELDS.COMMODITY, { startAscending: true }),
      sortable: false,
      flex: 1,
    },
    {
      field: 'material',
      headerName: 'Material',
      renderHeader: () =>
        renderHeaderWithSort('Material', SORTABLE_FINISHED_GOOD_FIELDS.MATERIAL_TYPE, { startAscending: true }),
      sortable: false,
      flex: 1,
    },
    {
      field: 'type',
      headerName: 'Type',
      renderHeader: () => renderHeaderWithSort('Type', SORTABLE_FINISHED_GOOD_FIELDS.TYPE, { startAscending: true }),
      sortable: false,
      flex: 1,
    },
    {
      field: 'netWeight',
      headerName: 'Net Weight',
      headerAlign: 'right',
      align: 'right',
      renderCell: params => `${formatNumber(params?.row?.netWeight)} ${defaultYardUm}`,
      renderHeader: () =>
        renderHeaderWithSort('Net Weight', SORTABLE_FINISHED_GOOD_FIELDS.NET_WEIGHT, {
          startAscending: false,
          align: 'right',
        }),
      sortable: false,
      flex: 1,
    },
    {
      field: 'itemCount',
      headerName: 'Count',
      headerAlign: 'right',
      align: 'right',
      sortable: false,
      flex: 1,
    },
    {
      field: 'status',
      headerName: 'Status',
      sortable: false,
      flex: 1,
    },
    {
      field: 'view',
      headerName: 'Actions',
      type: 'actions',
      width: 150,
      renderCell: params => getButtonCell(params, 'View', <VisibilityIcon />, () => navigate(params.row.id)),
    },
  ]
  return columns.filter(column => {
    if (column.field === 'itemCount') return enablePullApartFeatures
    return true
  })
}

const FinishedGoodsGrid = props => {
  const navigate = useNavigate()
  const { filter, setFilter } = props

  const { defaultYardUm } = useSelector(state => state.settings)
  const { enablePullApartFeatures = false } = useSelector(state => state.featureFlags?.variables || {})

  const renderHeaderWithSort = useMemo(() => generateRenderHeaderFunction(filter, setFilter), [filter])

  return (
    <DataGridWithSearch
      {...props}
      columns={getColumns(navigate, renderHeaderWithSort, defaultYardUm, enablePullApartFeatures)}
    />
  )
}

FinishedGoodsGrid.propTypes = DataGridWithSearch.propTypes

FinishedGoodsGrid.defaultProps = DataGridWithSearch.defaultProps

export default FinishedGoodsGrid
